// extracted by mini-css-extract-plugin
export default {"hideTooltip":"H8-z","fadeIn":"I8-z","delay":"J8-z","recommendedSizeTooltip":"K8-z"};